module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/Sonos-3da9219adc06d0477fd95276b01342cb.png";